import { StyleSheet, Platform } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { PlatformUtils } from '@vfgroup-oneplatform/foundation/Utils';

const isIPhoneWithNotch = PlatformUtils.isIPhoneDeviceWithNotch();

export default StyleSheet.create({
  addCardSection: {
    marginBottom: 20,
  },
  sectionTitleContainer: {
    marginVertical: 20,
  },
  sectionTitle: {
    fontSize: 24,
    color: Colors.blackTwo,
    fontWeight: 'bold',
  },
  scrollViewContentContainer: {
    marginHorizontal: 12,
    marginTop: Platform.OS === 'ios' ? (isIPhoneWithNotch ? 60 : 41) : 60,
    paddingBottom: Platform.OS === 'ios' ? (isIPhoneWithNotch ? 180 : 140) : 170,
  },
  scrollViewContentContainerWithTray: {
    paddingBottom: Platform.OS === 'ios' ? (isIPhoneWithNotch ? 145 : 110) : 145,
  },
});
